var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoIframeQuickActions = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.00049C21 4.89592 20.1046 4.00049 19 4.00049H13C11.8954 4.00049 11 4.89592 11 6.00049C11 7.10506 11.8954 8.00049 13 8.00049H19C20.1046 8.00049 21 7.10506 21 6.00049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45066 10.0005L5 14.5005L9.45066 19.0005L11 17.4345L8.11842 14.5005L11 11.5755L9.45066 10.0005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5493 19.0005L19 14.5005L14.5493 10.0005L13 11.5665L15.8816 14.5005L13 17.4255L14.5493 19.0005Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoIframeQuickActions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_iframe_quick_actions.5ef88865ac628fc235e0228f8c10a687.svg";